// Hidden bot trap for public forms. The field name is deliberately meaningless:
// browsers and password managers autofill anything that looks like "company" or
// "website", and the old "company" trap was silently discarding real signups
// that Chrome had filled with a counselor's practice name. Keep in sync with
// HONEYPOT_FIELD in src/server/routes/auth.js.
export const HONEYPOT_FIELD = 'hp_ref_code';

export const honeypotInputProps = {
  type: 'text',
  name: HONEYPOT_FIELD,
  tabIndex: -1,
  autoComplete: 'off',
  'aria-hidden': 'true',
  // Opt-outs for LastPass, 1Password, Bitwarden and Dashlane.
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other',
  style: { position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 },
};

// Shown on the login page when signup returns no user — usually because an
// account already exists for that email (the API won't say which, by design).
export const ACCOUNT_MAY_EXIST_NOTICE =
  'An account may already exist for that email. Log in below, or use “Forgot password?” to set a new password.';
